import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Braintree_customer } from '../models/accounting/banking/braintree_customer';
import { Braintree_credit_card } from '../models/accounting/banking/braintree_credit_card';
import { BraintreeService } from '../providers/braintree.service';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class PaymentCardService {

  constructor(private http: HttpClient, private braintreeService: BraintreeService) { }


  create(card_model: any): Promise<Braintree_credit_card> {

       return new Promise((resolve, reject) => {

        this.braintreeService.submitPaymentMethod(card_model).then((braintree_response: any) => {

          let bt:any = braintree_response.creditCards[0];

           this.handleCreateCard(card_model, bt).then(pay_method => {
             resolve(pay_method);
           }).catch(error => {
             reject(error);
           });

        }).catch(error => {
          reject(error);
        });

    });


  }

  private handleCreateCard(card_model: any, bt: any): Promise<Braintree_credit_card> {

 //   console.log(bt);

     let post_data = {
        data: {
          type: 'braintree_payment_card_request',
          attributes: { braintree_payment_card_model: {
              customer_id: card_model.customer_id,
              system_customer_id: card_model.system_customer_id,
              cardholder_name: card_model.cardholder_name,
              masked_number: bt.details.bin.substring(0,3) + "******" + bt.details.lastFour,
              exp_date: card_model.month + "/" + card_model.year,
              country: card_model.country,
              postal_code: card_model.postal_code,
              first_name: card_model.first_name,
              last_name: card_model.last_name,
              card_type: bt.details.cardType
            },
            nonce: bt.nonce
           }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'accounting/banking/braintree_create_credit_card',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='sms_braintree_credit_card'){

                         resolve(response.data);

                       }  else {
                         if(response.text){
                           reject(response.text);
                         } else {
                          reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : error);
                  }
             });
           });

  }

  hide(card: Braintree_credit_card): Promise<boolean> {
  	let put_data = {
        data: {
          type: 'card_hide_request',
          attributes: { system_payment_method_id: card.system_payment_method_id }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'accounting/banking/braintree_credit_cards',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='card_hide_response') {
                       	resolve(response.data);
                       }  else {
                       	if(response.text){
                       		reject(response.text);
                       	} else {
                        	reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
  }


}
